export default function (container: HTMLElement, onFinished: () => void) {
  let timer: number | null = null;
  
  const fields = Array.from(
    container.querySelectorAll<HTMLInputElement>('input[data-forder]')
  );
  if(fields.length < 1) {
    return null;
  }

  fields.sort((a, b) => {
    const orderA = parseInt(a.dataset.forder || '0', 10);
    const orderB = parseInt(b.dataset.forder || '0', 10);
    return orderA - orderB;
  });

  const eventHandlers: Array<(event: KeyboardEvent) => void> = [];

  fields.forEach((field, index) => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === 'Tab') {
        event.preventDefault();
        const nextIndex = index + 1;

        if (nextIndex < fields.length) {
          fields[nextIndex].focus();
        } else if(event.key === 'Enter') {
          if(!timer) {
            timer = setTimeout(() => {
              onFinished();
            }, 250);
          }
        }
      }
    };
    field.addEventListener('keydown', handler);
    eventHandlers.push(handler);
  });

  if (fields.length > 0) {
    fields[0].focus();
  }

  const destroy = () => {
    fields.forEach((field, index) => {
      field.removeEventListener('keydown', eventHandlers[index]);
    });
  };

  return {
    destroy,
  };
}
